import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

const DEFAULT_ROUTE = '/tags';
const routes = [DEFAULT_ROUTE];

const DefaultRedirect = () => {
    const { pathname } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!routes.includes(pathname)) {
            navigate(DEFAULT_ROUTE);
        }
    }, [navigate, pathname]);

    return null;
};

export default DefaultRedirect;
